
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LoadingTemplate extends Vue {
  public showSpinner: boolean = false;
  public fadeIn: boolean = false;
  public isFadingOut: boolean = false;
  private spinnerTimer: number | null = null;

  private mounted() {
    // Trigger fade-in immediately
    this.$nextTick(() => {
      this.fadeIn = true;
    });

    // Show spinner after 1000ms delay (prevents flicker on fast loads)
    this.spinnerTimer = window.setTimeout(() => {
      this.showSpinner = true;
    }, 1000);
  }

  private beforeDestroy() {
    if (this.spinnerTimer) {
      clearTimeout(this.spinnerTimer);
    }
  }

  // Method to trigger fade-out animation
  public fadeOut() {
    this.isFadingOut = true;
  }
}
